<ion-app>
  <div class="resolution-overlay">
    <h1>Please rotate your device</h1>
  </div>
  <ion-router-outlet [swipeGesture]="false"></ion-router-outlet>
</ion-app>
